import EnquiriesManagement from '../EnquiriesManagement';

const SkilledEnquiries = () => {
  return <EnquiriesManagement serviceType="skilled" />;
};

export default SkilledEnquiries;